import ohm from 'ohm-js'
// If you need to add support for a new field, look at replaceInputInScreenSettingRule

/**
 * replaceInputInScreenSettingRule
 * Takes a screening rule  and replaces the field name with the corresponding formData value
 * @param rule screening setting rule, E.g. 'newpatient = 1 | reason = 1029'
 * @param formData current user input form data
 * @returns string
 */
const replaceInputInScreenSettingRule = (rule, formData) => {
  // If you need to add support for a new field. Start by adding the field the replacement map.
  // The key is the field name inside formData, the value is a regex for field inside the rule
  const replacement = {
    newPatient: new RegExp('newpatient', 'g'),
    reason: new RegExp('reason', 'g'),
    insuranceProviderId: new RegExp('insurance_provider_id', 'g'),
    isTelehealth: new RegExp('telehealth', 'g')
  }

  // Some fields in formData have different type than the rules,
  const formDataCasted = { ...formData }
  // newPatient is a bool and the rule has integers, so we cast the bool to int
  formDataCasted.newPatient = formData?.newPatient ? 1 : 0

  for (const field in replacement) {
    rule = rule.replace(replacement[field], formDataCasted[field])
  }
  return rule
}

export class ScreeningSettings {
  constructor () {
    // See https://github.com/harc/ohm/blob/master/examples/math/index.html
    const gdef = `ScreenQs {
    Exp = OrBoolExp
    OrBoolExp = OrBoolExp "|" AndBoolExp -- or
    | AndBoolExp
    AndBoolExp = AndBoolExp "and" EqExp -- and
    | EqExp
    EqExp  = number "=" number
    number = digit+ | "undefined"
  }`
    this.grammar = ohm.grammar(gdef)

    // Define an operation named 'eval' which evaluates the expression.
    // See https://github.com/cdglabs/ohm/blob/master/doc/api-reference.md#semantics
    this.semantics = this.grammar.createSemantics().addOperation('eval', {
      Exp (e) {
        return e.eval()
      },
      EqExp (left, op, right) {
        return left.eval() === right.eval()
      },
      AndBoolExp_and (left, op, right) {
        return left.eval() && right.eval()
      },
      OrBoolExp_or (left, op, right) {
        return left.eval() || right.eval()
      },
      number (_) {
        return parseInt(this.sourceString, 10)
      }
    })
  }

  hasInsuranceSetting (rule) {
    return rule && rule.includes('insurance_provider_id')
  }

  static hasTelehealthEnabled (rule) {
    return rule && rule.includes('telehealth = 0')
  }

  apply (rule, data) {
    if (!rule) { return 0 }

    let result
    rule = replaceInputInScreenSettingRule(rule, data)
    const m = this.grammar.match(rule)
    if (m.succeeded()) {
      result = this.semantics(m).eval()
    } else {
      console.error(m.message)
      return 0
    }
    return result
  }
}
